import Rule from "../Rule";

export default class RuleOAApprovalRequiredBeforeMovingToReadyToDeliver extends Rule {
  static message = "Approval is required before moving to Ready to Deliver.";

  run() {
    const currentOrderActivity =
      this.currentChartData.orderActivity[this.orderActivityId];
    const futureOrderActivity =
      this.futureChartData.orderActivity[this.orderActivityId];

    if (
      currentOrderActivity.status === 1 &&
      futureOrderActivity.status === 2 &&
      futureOrderActivity.isApproved !== true
    ) {
      return this.fail();
    } else {
      return this.pass();
    }
  }
}
